module.exports = __webpack_public_path__ + "static/media/1-2.e6666575.png";